import { FC } from "react";
import { Chip } from "@mui/material";
import { green } from "@mui/material/colors";
import { FilteredRdsSnapshotSourceResourceItem } from "../../../../../../../../services/cloudchipr.api";
import type { ICellRendererParams } from "ag-grid-community";

export const RdsSnapshotExistsCellRenderer: FC<
  ICellRendererParams<FilteredRdsSnapshotSourceResourceItem>
> = ({ data }) => {
  const exists = data?.resource?.exists;

  if (!exists) {
    return (
      <Chip label="Deleted" size="small" variant="outlined" color="default" />
    );
  }

  return (
    <Chip
      label="Available"
      size="small"
      variant="outlined"
      sx={{
        color: "success.light",
        borderColor: green[200],
      }}
    />
  );
};
